import React, { useEffect, useState } from "react";
//import BookingForm from "./bookingForm";
import Card from "../Home/Card";
import Hero from "./Hero";
import QuickSelection from "../Home/QuickSelection";
//import Recommended from "../Home/recommended";
import Install from "../PWA/install";
import WhyChooseUs from "./whyChooseUs";
import Offers from "./Offers";
import Services from "./Services";
import HowItWorks from "./howItWorks";
import Faq from "./Faq";
import OurOffering from "./OurOffering"
import TourCard from "./TourPackages"
import FeaturedHome from "./FeaturedHome";

let deferredPrompt;

const IndexPage = () => {
  const [installable, setInstallable] = useState(false);
  const [loading, setLoading] = useState(true);

  const handleInstallClick = () => {
    setInstallable(false);
    if (deferredPrompt) {
      deferredPrompt.prompt();
      deferredPrompt.userChoice.then((choiceResult) => {
        if (choiceResult.outcome === "accepted") {
         // console.log("User accepted the install prompt");
        } else {
          //console.log("User dismissed the install prompt");
        }
        deferredPrompt = null;
      });
    }
  };

  useEffect(() => {
    const timer = setTimeout(() => {
      setLoading(false);
    }, 1000);

    const handleBeforeInstallPrompt = (e) => {
      e.preventDefault();
      deferredPrompt = e;
      setInstallable(true);
    };

    const handleAppInstalled = () => {};

    window.addEventListener("beforeinstallprompt", handleBeforeInstallPrompt);
    window.addEventListener("appinstalled", handleAppInstalled);

    return () => {
      clearTimeout(timer);
      window.removeEventListener("beforeinstallprompt", handleBeforeInstallPrompt);
      window.removeEventListener("appinstalled", handleAppInstalled);
    };
  }, []);

  const handleCloseClick = () => {
    setInstallable(false);
  };

  return (
    <>
    <div className={`mb-20 ${installable ? 'pb-48' : ''}`} style={{ fontFamily: 'Lato, sans-serif' }}>
      <Hero />
      <OurOffering/>
     {/* <Services/> */}
     <FeaturedHome />
     <TourCard/>

      <Offers/>
      
      <WhyChooseUs/>
     {/*} <HowItWorks/> */}
      <Faq/>
      </div>

   {installable && (
  <div className="fixed bottom-0 left-0 w-full bg-white shadow-lg px-4 py-3 z-[9999] font-lato">
    <Install
      installable={installable}
      onInstallClick={handleInstallClick}
      onCloseClick={handleCloseClick}
    />
  </div>
)}
      </>
   
  );
};

export default IndexPage;
